<template>
  <div>
    <div>
      <b>{{ selectedEmployeeTitle + ' : ' }}</b>
      <span v-if="!selectedEmployeeName" class="title error--text">
        กรุณาเลือกผู้ส่งต่อ
      </span>
      <span v-else class="title success--text" v-text="selectedEmployeeName || ''" />
    </div>
    <v-row v-if="!noSearch">
      <v-col class="pb-0">
        <v-text-field
          v-model="keyword"
          label="ค้นหาด้วย ชื่อ-สกุล บุคลากร"
          hint="ต้องมีอักขระ 3 ตัวขึ้นไป"
          persistent-hint
          outlined
          dense
          @keyup="keyword.length < 2 ? clearSearch() : onSearch()"
        />
      </v-col>
      <v-col cols="auto" class="mt-n3">
        <v-btn color="primary" :disabled="keyword.length < 2" depressed @click="onSearch()">
          <v-icon>mdi-magnify</v-icon>
          ค้นหา
        </v-btn>
      </v-col>
      <v-col cols="12" class="pt-0">
        <div v-if="isload">
          <v-card outlined height="224">
            <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
          </v-card>
        </div>
        <div v-else>
          <v-card outlined>
            <v-virtual-scroll v-if="list.length > 0" bench="2" height="224" item-height="64" :items="list">
              <template v-slot="{ item }">
                <v-list-item
                  :key="item"
                  :style="selectedEmployee === item.employeeID ? 'background-color: #eee' : ''"
                  @click="onSelect(item)"
                >
                  <v-list-item-action>
                    <v-btn
                      fab
                      x-small
                      depressed
                      :outlined="selectedEmployee !== item.employeeID"
                      :color="selectedEmployee !== item.employeeID ? 'primary darken-2' : 'success'"
                    >
                      <v-slide-x-reverse-transition>
                        <v-icon v-if="selectedEmployee === item.employeeID">
                          mdi-check
                        </v-icon>
                      </v-slide-x-reverse-transition>
                    </v-btn>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item[`employeeName${$lang}`] }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
              </template>
            </v-virtual-scroll>

            <div v-else class="py-2 px-4 grey--text">
              ไม่มีข้อมูลค้นหา
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    selectedEmployee: {
      type: String,
      default: ''
    },
    selectedEmployeeTitle: {
      type: String,
      default: ''
    },
    selectedEmployeeName: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    noSearch: {
      type: Boolean,
      default: false
    },
    isload: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      keyword: ''
    };
  },

  methods: {
    onSearch() {
      this.isload = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        this.isload = false;
      }
      this.timer = setTimeout(() => {
        this.onSearchApi();
      }, 500);
    },
    onSearchApi() {
      this.$emit('search', this.keyword);
    },

    onSelect(item) {
      this.$emit('select', item);
    },
    clearSearch() {
      this.list = [];
    }
  }
};
</script>

<style lang="scss" scoped></style>
